import { formatNumberWithCommas } from "@/utils";
import { CalendarIcon, GroupIcon, ThumbaCoin } from "@roman/shared/components/Icons";
import type { Round } from "@roman/shared/types/Round";
import { DeadlineTime } from "./DeadlineTime";

export const RoundInfoFooter = ({
  round,
  onClick,
}: {
  round: Round;
  onClick: () => void;
}) => {
  return (
    <div onClick={onClick} className="flex flex-col justify-between p-1 mt-[10px]">
      <div className="flex items-center space-x-2">
        <ThumbaCoin className="h-[22px] w-[22px]" />
        {Number.parseInt(round.entryFee) !== 0 ? (
          <div>
            <span className="text-base font-bold">{formatNumberWithCommas(round.entryFee)}pt</span>
            <span className="text-sm">/1回</span>
          </div>
        ) : (
          <div>
            <span className="text-base font-bold">無料</span>
          </div>
        )}
      </div>
      <div className="flex justify-end mt-2 gap-2">
        <div className="flex items-center">
          <GroupIcon className="text-dark-gray w-[18px] h-[18px]" />
          <div className="flex flex-col px-2">
            <span className="text-dark-gray text-[10px] font-normal whitespace-nowrap leading-tight">エントリー数</span>
            <span className="font-bold text-xs whitespace-nowrap">
              {round.numEntries}/{round.maxNumEntries}
            </span>
          </div>
        </div>

        <div className="flex items-center">
          <CalendarIcon className="text-dark-gray w-[18px] h-[18px]" />
          <div className="flex flex-col px-2">
            <span className="text-dark-gray text-[10px] font-normal whitespace-nowrap leading-tight">開催日</span>

            <DeadlineTime entryCloseTime={round.entryCloseTime} />
          </div>
        </div>
      </div>
    </div>
  );
};
